import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class ClassGroupResultsRoute extends Route 
{
	@service ajax
	@service store
	
	screenId = null
	
	resultsTimer = null
	configTimer = null
	
	resultsRefreshInterval = 10000
	configRefreshInterval = 60000
	
	classGroupTimer = null
	classGroupRefreshInterval = 10000
	
	async model(params) 
	{
		this.screenId = params.screen_id;
			
		const results = await this.fetchResults();
		const config = await this.fetchConfig();
		
		return {results:results,config:config};
	}
	
	setupController(controller, model) 
	{
		controller.set('results', model.results);
	    controller.set('event', this.modelFor('event'));
		
		controller.set('screenConfig',model.config);
	}
	
	async fetchResults()
	{
		let results = await this.ajax.request("individualResults");
		results = await results.map(function(result)
		{
			return result.data.attributes;
		});
		return results;
	}
	
	async fetchConfig()
	{
		let configs = await this.ajax.request("screenConfig.json");
		let config = null;
		for(const screen of configs)
		{
			if(screen.id == parseInt(this.screenId))
				config = screen.config;
		}
		return config;
	}
	
	async fetchResultsLoop()
	{
		cancel(this.resultsTimer);
		this.resultsTimer = later(this,async function()
		{
			const results = await this.fetchResults();
			this.controller.set('results', results);
			
			this.fetchResultsLoop();
		},this.resultsRefreshInterval);
	}
	
	async fetchConfigLoop()
	{
		cancel(this.configTimer);
		this.configTimer = later(this,async function()
		{
			const config = await this.fetchConfig();
			this.controller.set('screenConfig', config);
			
			this.fetchConfigLoop();
		},this.configRefreshInterval);
	}
	
	async fetchClassGroups()
	{
		const classGroups = await this.ajax.request("class-groups");
		let type = this.store.modelFor('classGroup');
		let serializer = this.store.serializerFor('classGroup');
		this.store.push(serializer.normalizeArrayResponse(this.store, type, classGroups));
	}
	
	async fetchClassGroupsLoop()
	{
		cancel(this.classGroupTimer);
		this.classGroupTimer = later(this,async function()
		{			
			this.fetchClassGroups();
			this.fetchClassGroupsLoop();
		},this.classGroupRefreshInterval);
	}
	
	activate(transition)
	{
		this.fetchResultsLoop();
		this.fetchConfigLoop();
		this.fetchClassGroupsLoop();
	}
	
	deactivate(transition)
	{
		cancel(this.resultsTimer);
		cancel(this.configTimer);
		cancel(this.classGroupTimer);
	}
}